import { __ } from "@wordpress/i18n";
export default class PaymentLink {
  constructor() {
      this.openCheckoutFieldSection();
  }

  openCheckoutFieldSection() {
    const url = new URLSearchParams(location.href);
    if (url.has("vindi-payment-link")) {
      const addresses = document.querySelectorAll(".edit_address");

      addresses.forEach((address) => {
        address.style.display = "block";
      });

      if (url.has("gateway")) {
        this.updateLinkGateway(url.get("gateway"));
      }
    }
  }

  updateLinkGateway(gateway) {
    const select = document.querySelector("#_payment_method");
    select.value = gateway;
  }
}
